export default __webpack_public_path__ + "static/media/nicole.7cd88566.png";